<mat-card class="card-mobile" appearance="outlined">
    <mat-card-header style="padding: 12px 12px 0px 12px;">
    <div class="card-header-mobile">
      <img class="card-provider-image-mobile" [src]="photo || environment.default_provider_photo_url" alt="Provider Photo" style="margin-right: 40px;" />
      <div class="card-provider-wait-time-container-mobile">
        <div class="card-provider-book-as-soon-as-mobile" *ngIf="availability != null && waitTime!=null && waitTime!=''">
            {{soonAsText}}
        </div>
        <div *ngIf="availability != null && waitTime!=null && waitTime!=''" class="card-provider-availability-mobile">
            {{waitTime}}
        </div>
        <div *ngIf="availability == null" class="card-provider-availability-mobile"></div>
      </div>
    </div>
    </mat-card-header>
    <mat-card-content class="card-provider-content-mobile">
      <mat-card-title class="card-provider-title-mobile" style="margin-bottom: 2px;">{{name}}</mat-card-title>
      <mat-card-subtitle class="card-provider-subtitle-mobile" style="margin-bottom: 12px;" >{{specialties}}</mat-card-subtitle>
      <div class="card-provider-city-mobile">
        <svg width="6" height="9" viewBox="0 0 6 9" style="padding-right: 4px;" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="3.31578" cy="2.5" rx="2.63158" ry="2.5" fill="#959595"/>
          <line x1="3.28949" y1="4" x2="3.28949" y2="9" stroke="#959595"/>
        </svg>
        <div>{{city}}</div>
      </div>
    </mat-card-content>
    <mat-card-actions class="card-provider-actions-mobile">
        <div *ngIf="distance != null && distance != ''" class="card-provider-detail-bottom-left" style="display: flex;">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.10889 0L5.69309 9.12723L4.54439 5.13755L0.812091 4.05578L9.10889 0Z" fill="#959595"/>
          </svg>
          <div style="padding-left: 4px;">
            {{distance}} {{milesAwayText}}
          </div>
        </div>
        <div *ngIf="distance == null || distance == ''" class="card-provider-detail-bottom-left"></div>
        <button mat-button *ngIf="availability!=null || (isOpenScheduling != null && isOpenScheduling == true && departmentId != null)" class="action-button-primary" (click)="bookNow()">{{scheduleText}}</button>
        <button mat-button *ngIf="availability==null && (isOpenScheduling == null || isOpenScheduling != true)" class="action-button-primary" (click)="callNow()">{{callText}}</button>
    </mat-card-actions>
</mat-card>
